import React from 'react';

interface ShopIconProps {
  className?: string;
}

const ShopIcon: React.FC<ShopIconProps> = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M4 11.2444V22H20V11M4 5.9111V2H20V6M2 6H22V10L21.3008 10.4195C20.1924 11.0846 18.8076 11.0846 17.6992 10.4195L17 10L16.3008 10.4195C15.1924 11.0846 13.8077 11.0846 12.6993 10.4195L12 10L11.3007 10.4195C10.1923 11.0846 8.80765 11.0846 7.69925 10.4195L7 10L6.30075 10.4195C5.19235 11.0846 3.80765 11.0846 2.69927 10.4195L2 10V6ZM9.5 16H14.5V22H9.5V16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ShopIcon;